<template lang="pug">
  section(class="separable")
    app-modal-inserir-documentos(
      v-if="showModalInserirDocumentos",
      @closeModal="closeModalDocumentos",
      :titulo="tituloModal",
      :protocolo="this.$route.params.idCadastro"
    )
    app-modal-visualiza-pdf(
      v-if="showModalVisualizaPdf",
      @closeModal="closeModalVisualizaPdf",
      :titulo="tituloModal",
      :tipo="tipoModal",
      :conteudo="conteudoModal",
      :isVTN="false",
      :isImagem="isImagem"
      :tituloDocumento="tituloDocumento"
    )
    div(class="container")
      el-row(v-if="conversa")
        el-col(:span="24")
          div(class="card")
            div(class="card-header") {{ mensagens.assunto }}
            div(class="card-body")
              app-collapse(
                v-for="(mensagem, index) in mensagens.mensagemList",
                :key="mensagem.id",
                :title="setPessoaNomeRazaoSocial(mensagem.remetente) + ' - ' + moment(mensagem.dataEnviada).add(+0, 'hours').locale('pt-br').calendar()"
                :collapsed="index < (mensagens.mensagemList.length - 1) ? '1' : '0'"
              )
                p(v-html="mensagem.conteudo")
                div(v-if="conversaVistoriaRemota")
                  app-documentos-posse-mansa-e-pacifica(
                    v-if="conversa && index === 0 && !conversa.isPossivelResponder"
                    :conversa="conversa",
                    :tipoCadastro="processo.tipo.codigo"
                    :mensagemOutros="mensagemOutros"
                  )
                p(v-if="conversa && conversaNotificacaoDocumentoInvalido && conversa.status === 'ABERTA' && !conversaVistoriaRemota")
                  span.click(@click="showModalDocumentos") Clique aqui
                  |  para inserir os documentos
                div(v-if="verificaStatusAmbiental")
                  app-visualizar-monitoramento-area-tab(:idProcesso="idProcessoMonitoramento", :numeroProcesso="idNumeroProcessoMonitoramento")
                div(v-if="despachos && isPa && conversa.despacho")
                  app-despacho-simplificado(:despachos="despachos", :title="'Análise ' + setoresFormatado[conversa.despacho.setor]")
                el-row(v-if="!conversaVistoriaRemota")
                  el-table(
                    :data='mensagem.anexoList',
                    stripe
                  )
                    div(slot='empty')
                      span Não há anexos disponíveis.
                    el-table-column.td-column-anexo(
                      prop='nome',
                    )
                    el-table-column.td-column-anexo(
                      align="center",
                      width="85"
                      )
                        template(slot-scope='scope')
                          app-action-button(
                            v-if="isAp"
                            :disabled="!isDocumentoParaVisualizacao(scope.row)"
                            :cor="!isDocumentoParaVisualizacao(scope.row) ? '#C0C4CC' : '#666666'",
                            :text="!isDocumentoParaVisualizacao(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar' ",
                            icone="eye",
                            fontSize="18",
                            @click="abrirDocumento(scope.row)"
                          )
                          app-action-button(
                            icone="download",
                            nome="file_download",
                            @click="baixarAnexo(scope.row)",
                            hoverColor="#009f61",
                            text="Baixar anexo"
                          )
                .buttons
                  el-button(
                    v-if="!(conversa.status === 'ENCERRADA') && conversaNotificacaoDocumentoInvalido",
                    type="default",
                    @click="$router.push({ name: 'caixa-entrada' })"
                  ) Cancelar
                div.dataLimite(
                  v-if="mensagem.dataLimiteResposta && (conversa.despacho || conversaVistoriaRemota) && getAssuntoMensagem()"
                )
                  b Data limite para resposta: {{ mensagem.dataLimiteFormatada }} &nbsp
              app-resposta(
                v-if="!(conversa.status === 'ENCERRADA') && !conversa.isPossivelResponder && !conversaNotificacaoDocumentoInvalido && !conversaVistoriaRemota",
                :showAnexos="conversa && conversaNotificacaoDocumentoInvalido ? false : true"
                @mensagemRespondida="buscarConversa"
              )

</template>

<script>
import moment from 'moment'
import vuex from '../../../../store'
import AppResposta from './AppResposta'
import AppDocumentosPosseMansaEPacifica from './AppDocumentosPosseMansaEPacifica'
import AppActionButton from '../../../../components/AppActionButton'
import Helper from '../../../../utils/helperPessoa'
import store from '@/store'
import { mapActions } from 'vuex'
import AppCollapse from '@/components/AppCollapse'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppVisualizarMonitoramentoAreaTabVue from '../../../analise/components/modal/AppVisualizarMonitoramentoAreaTab.vue'
import AppModalInserirDocumentos from './AppModalInserirDocumentos.vue'
import AppDespachoSimplificado from '../../../../components/AppDespachoSimplificado.vue'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'
import utils from '@/utils/utils'
const { visualizarDocumentosPDF } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const { setoresFormatado } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {
  async beforeRouteEnter (to, from, next) {
    const usuario = await store.dispatch('auth/getUsuario')

    await vuex.dispatch('conversas/read', {
      idConversa: to.params.idConversa,
      idUsuario: usuario.id,
      idPessoa: usuario.pessoa.id
    }).then(() => {
      vuex.commit('loader/RESET_LOADER')
      next()
    }).catch((error) => {
      vuex.commit('loader/RESET_LOADER')
      vuex.dispatch('showErrorNotificacao', error)
    })
  },

  beforeRouteLeave (to, from, next) {
    if ((this.resposta.conteudo !== null && this.resposta.conteudo !== '') || this.resposta.anexoList.length !== 0) {
      this.confirmBox(this.$messages.CANCELAR_RESPOSTA, this.$messages.TITULO_WARNING,
        () => {
          this.$store.dispatch('conversas/clearResposta')
          next()
        },
        () => { })
    } else {
      this.$store.dispatch('conversas/clearResposta')
      next()
    }
  },

  components: {
    AppResposta,
    AppActionButton,
    AppCollapse,
    AppModalInserirDocumentos,
    'app-visualizar-monitoramento-area-tab': AppVisualizarMonitoramentoAreaTabVue,
    AppDespachoSimplificado,
    AppDocumentosPosseMansaEPacifica,
    AppModalVisualizaPdf
  },

  mixins: [
    AppNotificacao
  ],

  created () {
    this.buscarConversa()
  },

  data () {
    return {
      moment,
      processo: null,
      idProcessoMonitoramento: 0,
      idNumeroProcessoMonitoramento: '',
      showModalInserirDocumentos: false,
      conversa: null,
      tituloModal: '',
      despachos: [],
      isPa: process.env.ESTADO === 'pa',
      isMa: process.env.ESTADO === 'ma',
      mensagemOutros: 'Laudo de vistoria ou outros arquivos que se fizerem necessário.',
      tipoModal: null,
      conteudoModal: null,
      showModalVisualizaPdf: false,
      isImagem: false,
      tituloDocumento: '',
      setoresFormatado
    }
  },

  computed: {
    mensagens () {
      return this.$store.getters['conversas/mensagens']
    },
    resposta () {
      return this.$store.getters['conversas/resposta']
    },
    verificaStatusAmbiental () {
      return this.processo?.statusAmbiental === 'STATUS4' || this.processo?.statusAmbiental === 'STATUS5'
    },
    conversaNotificacaoDocumentoInvalido () {
      return this.conversa?.tipo === 'NOTIFICACAO_DOCUMENTOS_INVALIDOS'
    },
    conversaVistoriaRemota () {
      return this.conversa?.tipo === 'VISTORIA_REMOTA'
    },
    isAp () {
      return process.env.ESTADO === 'ap'
    }
  },

  methods: {
    ...mapActions({
      getProcessoByProtocolo: 'processos/getProcessoByProtocolo',
      getConversaById: 'conversas/findById'
    }),
    baixarAnexo (data) {
      this.$store.commit('loader/SET_LOADER')
      this.$store.dispatch('conversas/baixarDocumento', {
        id: data.id,
        nome: data.nome
      })
        .then(() => {
          this.$store.commit('loader/RESET_LOADER')
        }).catch(() => {
          this.$store.commit('loader/RESET_LOADER')
        })
    },

    async buscarConversa () {
      this.conversa = await this.getConversaById(this.$route.params.idConversa)
      if (this.conversa?.tipo === 'NOTIFICACAO_ARQUIVAMENTO') {
        this.despachos.push(this.conversa.despacho)
      }
      this.processo = await this.getProcessoByProtocolo(this.$route.params.idCadastro)
      if (this.processo.id && this.processo.numeroProcesso) {
        this.idProcessoMonitoramento = this.processo.id
        this.idNumeroProcessoMonitoramento = this.processo.numeroProcesso
      }
    },
    setPessoaNomeRazaoSocial (pessoa) {
      return Helper.getPessoaNome(pessoa)
    },
    getDataEnvio (data) {
      return moment(data).format('DD/MM/YYYY') + ' - ' + moment(data).format('HH:mm:ss')
    },
    getDataLimite (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    showModalDocumentos () {
      this.tituloModal = 'Retificação de documentos'
      this.showModalInserirDocumentos = true
    },
    closeModalDocumentos () {
      this.showModalInserirDocumentos = false
    },
    getAssuntoMensagem () {
      if (this.mensagens.tipo === 'NOTIFICACAO_DAE' && this.isMa) {
        return false
      }
      return !(this.mensagens.assunto === 'DAE - Parcela Única' || this.mensagens.assunto === 'Arquivamento de processo' || this.mensagens.assunto === 'Desarquivamento de processo')
    },
    abrirImagem (row) {
      let extensao = utils.getExtensionFile(row.nome)
      return visualizarDocumentosPDF.extensaoImagens.includes(extensao)
    },
    isDocumentoParaVisualizacao (row) {
      let extensao = utils.getExtensionFile(row.nome)
      return visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)
    },
    abrirDocumento (documento) {
      this.tipoModal = 'DOCUMENTO_MENSAGEM'
      this.tituloModal = 'Documento'
      this.conteudoModal = documento.id
      this.isImagem = this.abrirImagem(documento)
      this.showModalVisualizaPdf = true
      this.tituloDocumento = 'Documento'
    },
    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    }

  }
}
</script>

<style lang="scss" scoped>
  .conteudo {
    margin: 0px 15px;
    text-align: left;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    color: #2c3e50;
  }

  .dataLimite {
    margin-top: 20px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .title {
    font-weight: 400;
  }

  .card {
    margin-top: 0;
  }

  .card .card-header {
    font-size: x-large;
    line-height: initial;
    padding: 23px 23px 0 23px;
  }
  .click {
    color: #009F61;
    cursor: pointer;
  }
  .buttons {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }

  @media (max-width: 780px) {
    .container {
      width: 315px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/components/centralMensagens/AppConversaMensagens.vue